/* Pup Club in the cart (Zack, 2026-09-27).
 *
 * A shopper who has put the Pup Club membership in the cart sees Pup Club
 * prices across the Bank site: the shop, product pages and product cards.
 * This is display only. Checkout still prices from the cart, and removing the
 * membership (or picking "No savings" in the cart) puts the standard prices
 * back on the next read.
 *
 * Publishes window.PK_CLUB_IN_CART, the html class pk-club-in-cart and a
 * pk:club-cart event whenever the answer changes. Bank pages only; Meta never
 * carries Pup Club.
 */
(() => {
  'use strict';

  const html = document.documentElement;
  if (html.dataset.pkEntry !== 'returning') return;

  const KEY = 'pk-club-in-cart';
  const HANDLE = 'pup-club-free-trial';

  const apply = (next) => {
    const changed = window.PK_CLUB_IN_CART !== next;
    window.PK_CLUB_IN_CART = next;
    html.classList.toggle('pk-club-in-cart', next);
    if (changed) {
      try { dispatchEvent(new CustomEvent('pk:club-cart', { detail: { inCart: next } })); } catch (_) { /* older engine */ }
    }
  };

  /* The last answer from this tab paints first, so a joined shopper does not
     see standard prices flash on every page. The cart read below corrects it. */
  let cached = false;
  try { cached = sessionStorage.getItem(KEY) === '1'; } catch (_) { /* storage blocked */ }
  window.PK_CLUB_IN_CART = cached;
  html.classList.toggle('pk-club-in-cart', cached);

  const isMembership = (line) => {
    const id = Number(window.PK_SHOPIFY_CATALOG?.membership?.variantId) || 0;
    return !!line && (line.handle === HANDLE || line.handle === 'pup-club-membership' || (id > 0 && Number(line.variant_id || line.id) === id));
  };

  const nativeFetch = window.fetch.bind(window);
  let seq = 0;
  const refresh = () => {
    const mine = ++seq;
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (mine !== seq || !cart || !Array.isArray(cart.items)) return;
        const next = cart.items.some(isMembership);
        try { if (next) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (_) { /* storage blocked */ }
        apply(next);
      })
      .catch(() => { /* keep the last answer */ });
  };
  window.PKClubCart = { refresh };

  /* Any cart write on this page (drawer, cart page, add buttons, Join) re-reads the cart. */
  const CART_WRITE = /^\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/;
  window.fetch = function pkClubCartFetch(input, init) {
    const pending = nativeFetch(input, init);
    try {
      const raw = typeof input === 'string' ? input : (input && input.url) || '';
      const path = new URL(raw, location.href).pathname;
      if (CART_WRITE.test(path)) pending.then(() => setTimeout(refresh, 0), () => {});
    } catch (_) { /* not a URL we track */ }
    return pending;
  };

  refresh();
  addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
})();
